import { render, staticRenderFns } from "./CompanyDepartment.vue?vue&type=template&id=175b0f15&"
import script from "./CompanyDepartment.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports